// Onboarding-request intent (the 6th required record), mirroring backend
// RequestOut in api/v1/site_onboarding.py. request_id/requested_at/site_id are
// server-managed (immutable; stripped by toIn before edit). The two auth modes
// are stored as free str server-side, but the infra apply-time validator
// (orixen-validate-request.yml) pins them to the literals below, so the UI
// exposes them as defaulted single-option selects.

export type RequestStatus = "proposed" | "approved" | "rejected";

export const REQUEST_STATUSES = [
  { value: "proposed", label: "Proposed" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
] as const;

// Contract literals enforced by infra orixen-validate-request.yml (HA auth
// asserts kept under the Option-B validator). Single option today = the default.
export const HA_REMOTE_AUTH_MODES = [
  { value: "freeipa_command_line", label: "FreeIPA (command line)" },
] as const;

export const HA_LOCAL_AUTH_MODES = [
  { value: "trusted_networks", label: "Trusted networks" },
] as const;

export interface OnboardingRequestIn {
  requested_by: string | null;
  request_status: RequestStatus;
  site_boundary_slug: string | null;
  site_type: string | null;
  ha_instance_name: string | null;
  ha_local_url: string | null;
  // Backend NOT-NULL column — always send an array, never null.
  ha_local_trusted_subnets: string[];
  ha_remote_auth_mode: string;
  ha_local_auth_mode: string;
  ha_break_glass_required: boolean;
}

export interface OnboardingRequestConfig extends OnboardingRequestIn {
  site_id: string;
  request_id: string;
  requested_at: string;
}
